import * as React from 'react';
import { Navbar, Nav } from "react-bootstrap";
import "./Footer.scss"

export const Footer = () => {
    return(
        <Navbar className="footer">
            <Nav>
                <div className="footerContent">
                    <ul>
                        <li>© {new Date().getFullYear()} - Whitespace Work Software</li>
                        <li> | </li>
                        <li><a href="https://whitespacews.com" target="_blank" rel="noreferrer" data-testid="footerLinkWsHome">https://whitespacews.com</a></li>
                        <li> | </li>
                        <li><a href="https://whitespacews.com/privacy-policy/" target="_blank" rel="noreferrer" data-testid="footerLinkWsPrivacy">Privacy Policy</a></li>
                    </ul>
                    <ul>
                        <li>
                            <p>
                                This system is for official use by authorized personnel only.
                                By using this system, you agree to allow monitoring and recording of your activities on this system which may be provided to law enforcement or other investigative agencies for official reasons including criminal investigations.
                                Unauthorized or illegal activities on this system may be punishable by law.
                                By logging into this system you indicate your acceptance of these terms and agree to abide by the IT Acceptable Use Policy.
                            </p>
                        </li>
                    </ul>
                </div>
            </Nav>
        </Navbar>
    );
}
